export function operacaoAbastecimentosInRequest(params = {}) {
  return {
    type: '@operacaoabastecimento/OPERACAOABASTECIMENTOS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoAbastecimento(movi_codigo) {
  return {
    type: '@operacaoabastecimento/FIND_OPERACAOABASTECIMENTO',
    payload: { movi_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoabastecimento/FAILED_REQUEST',
  };
}

export function deleteOperacaoAbastecimento(movi_codigo, params) {
  return {
    type: '@operacaoabastecimento/DELETE_OPERACAOABASTECIMENTO',
    payload: { movi_codigo, params },
  };
}

export function updateOperacaoAbastecimento(operacaoabastecimentos, params) {
  return {
    type: '@operacaoabastecimento/UPDATE_OPERACAOABASTECIMENTO',
    payload: { operacaoabastecimentos, params },
  };
}

export function storeOperacaoAbastecimento(operacaoabastecimento, params) {
  return {
    type: '@operacaoabastecimento/STORE_OPERACAOABASTECIMENTO',
    payload: { operacaoabastecimento, params },
  };
}

export function successInRequest(
  operacaoabastecimentos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoabastecimento/SUCCESS_IN_REQUEST',
    payload: { operacaoabastecimentos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoabastecimento) {
  return {
    type: '@operacaoabastecimento/SUCCESS_REQUEST',
    payload: { operacaoabastecimento },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoabastecimento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoabastecimento/RECORD_FILTERING',
    payload: { params },
  };
}
